import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";
export const logout = createAction("auth/logout");

const initialState: authUser = {
  accessToken: "",
  tokenType: undefined,
  expiresIn: undefined,
  userId: undefined,
  userType: undefined,
  templateType: undefined,
  role: undefined,
  organizations: [],
  personalSession: undefined,
  currentSession: "myself",
  currentOrganizationId: undefined,
};
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    updateAuthentication: (
      state,
      action: PayloadAction<Partial<authUser>>
    ) => ({ ...state, ...action.payload }),
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const { updateAuthentication } = authSlice.actions;
export default authSlice.reducer;
